"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayHelper = void 0;
const MathHelper_1 = require("./MathHelper");
class ArrayHelper {
    static initArrayWithValues(length, creator) {
        const array = [];
        for (let i = 0; i < length; i++) {
            array.push(creator(i));
        }
        return array;
    }
    /**
     * Returns random value form array.
     * @param array T[]
     * @returns {T}
     */
    static getRandomValue(array) {
        return array[MathHelper_1.MathHelper.clamp(Math.round(Math.random() * array.length), 0, array.length - 1)];
    }
    /**
     * Sum of all numbers in array.
     * @param array number[]
     * @returns {number}
     */
    static arraySum(array) {
        return array.reduce((a, b) => { return a + b; }, 0);
    }
    /**
     * Fetch single value for the typeArr if it's either Array or Regular type.
     * @param typeArr <T>
     * @param index ArrayPos if it's an array.
     * @returns {T}
     */
    static fetchArrTypeValue(typeArr, indx) {
        return (Array.isArray(typeArr) ? typeArr[indx] : typeArr);
    }
    /**
     * Returns sum of condition hits.
     * @param array any[]
     * @param condition (element:any) => boolean
     * @returns {number} amount
    */
    static countWithCondition(array, condition) {
        return array.filter(item => condition(item)).length;
    }
    /**
     * Returns the last value of an array.
     * @param array <T>
     * @param index
     * @returns {T}
     */
    static fetchLastValue(array) { return array[array.length - 1]; }
    /**
     * Check if a value is out of reach of the supplied range.
     * Returns the "flipped" index of the range.
     * @param length the range start from index 0.
     * @param index
     * @returns {number}
     */
    static reviseIndexInLoopRange(length, index) {
        if (length <= 0) {
            debugger;
            throw new Error(`Error: ArrayHelper.getValueInLoopRange(): length must bigger than zero!`);
        }
        if (index > (length - 1)) {
            return index % length;
        }
        if (index < 0) {
            return length - (Math.abs(index) % length);
        }
        return index;
    }
    static removeFirstMatchElement(array, element) {
        for (let i = 0; i < array.length; i++) {
            if (array[i] === element) {
                array.splice(i, 1);
                return;
            }
        }
    }
    static indexOfArr(array, val) {
        for (let i = 0; i < array.length; i++) {
            const checkVal = array.indexOf(array[i]);
            if (checkVal >= 0)
                return checkVal;
        }
        return -1;
    }
    static removeFirstMatchElementWithCondition(array, condition) {
        for (let i = 0; i < array.length; i++) {
            if (condition(array[i])) {
                array.splice(i, 1);
                return;
            }
        }
    }
    /**
       * Swap Positions in an array
       * @param array
       * @param a First position
       * @param b Second position
       * @returns {T[]}
       */
    static swapPositions(array, a, b) {
        return [array[a], array[b]] = [array[b], array[a]];
    }
    /**
     * Uses an function trigger for each value in an dubbel array
     * Example usage -> "let count:number = 0; ArrayHelper.eachForEach(sizes, (val:number) => { count += val > 0 ? 1 : 0 })"
     * Example usage 2 -> "let count:number = 0; ArrayHelper.eachForEach(sizes, (val:number) => this.method(value))"
     * @param arr any:[][]
     * @param func (value:any) => void
     * @returns {void}
    */
    static eachForEach(arr, func) {
        for (let i = 0; i < arr.length; i++) {
            for (let k = 0; k < arr[i].length; k++) {
                func(arr[i][k]);
            }
        }
    }
    ;
    /**
     * Find out how many indexes there is in a mega MultiArray
     * @param arr any
     * @returns {number} amount of indexes.
    */
    static countAmountOfIndexes(arr, amm = 0) {
        if (Array.isArray(arr)) {
            for (let i = 0; i < arr.length; i++) {
                if (Array.isArray(arr[i]))
                    amm = this.countAmountOfIndexes(arr[i], amm);
                else
                    return amm + arr.length;
            }
        }
        return amm;
    }
    ;
    /**
    * Shuffles the array.
    * @param array Any
    */
    static shuffle(array) {
        for (let i = array.length; i; i--) {
            this.swapPositions(array, i - 1, Math.floor(Math.random() * i));
        }
        return array;
    }
}
exports.ArrayHelper = ArrayHelper;
//# sourceMappingURL=ArrayHelper.js.map